<template>
    <v-container fluid class="animated-background-container" v-resize="setCounts"
                 ref="animated_background_container" style="padding-top: 50px; padding-bottom: 50px;">
        <v-row v-for="row of rowCount" :key="row" no-gutters
               :class="{'animated-background-swipe-right': row % 2 == 0, 'animated-background-swipe-left': row % 2 == 1}"
        >
            <v-col v-for="column of colCount" :key="column"
                   style="display: flex; justify-content: center; align-items: center; height: 100px; width: 100px;">
                <small style="color: grey; opacity: 0.5;" class="weightless-element">+</small>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {TimelineMax, Sine} from 'gsap';

    export default {
        data: () => ({
            colCount: 0,
            rowCount: 0,
            xMin: -10,
            xMax: 10,
            yMin: -10,
            yMax: 10,
            timelines: []
        }),
        methods: {
            setCounts() {
                let computedStyle = getComputedStyle(this.$refs.animated_background_container);
                this.rowCount = Math.ceil(parseInt(computedStyle.height) / 100) - 2;//Minus 2 along with top and bottom padding to remove first and last rows.
                this.colCount = Math.ceil(parseInt(computedStyle.width) / 100);

                this.rowCount = this.rowCount > 0 ? this.rowCount : 0;
                this.colCount = this.colCount > 0 ? this.colCount : 0;
                this.$nextTick(() => {
                    this.killExistingTimelines();
                });
                this.$nextTick(() => {
                    this.startFloating();
                });
            },
            startFloating() {
                let positionsPerElement = 5,
                    secondsPerIteration = 5,
                    elements = document.querySelectorAll(".weightless-element");

                for (let i = 0; i < elements.length; i++) {
                    this.randomFloat(elements[i], positionsPerElement, secondsPerIteration);
                }
            },
            randomFloat(element, positions, duration) {
                let tl = new TimelineMax({repeat: -1, yoyo: true, delay: Math.random() * duration});
                this.timelines.push(tl);
                for (let i = 0; i < positions; i++) {
                    tl.to(element, duration, {
                        x: this.getRandomFloat(this.xMin, this.xMax),
                        y: this.getRandomFloat(this.yMin, this.yMax),
                        ease: Sine.easeInOut
                    });
                }
                return tl;
            },
            getRandomFloat(min, max) {
                return (min + Math.random() * (max - min));
            },
            killExistingTimelines() {
                this.timelines.forEach((timeline) => {
                    timeline.kill();
                });
                this.timelines = [];
            }
        },
    };
</script>

<style>
    .animated-background-container {
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: 0;
        left: 0;
        top: 0;
    }

    .animated-background-swipe-right {
        animation: swipe-right 1s cubic-bezier(0.68, -0.55, 0.265, 1.2);
    }

    @keyframes swipe-right {
        from {
            /*opacity: 0;*/
            transform: translateX(-100%);
        }
        to {
            /*opacity: 0.5;*/
            transform: translateX(0px);
        }
    }

    .animated-background-swipe-left {
        animation: swipe-left 1s cubic-bezier(0.68, -0.55, 0.265, 1.2);
    }

    @keyframes swipe-left {
        from {
            /*opacity: 0;*/
            transform: translateX(100%);
        }
        to {
            /*opacity: 0.5;*/
            transform: translateX(0px);
        }
    }
</style>